import 'css-chunksrc/client/common/zoneAvatar/styles.scss';export default {
  "zoneAvatar": "_zoneAvatar_12k5y_1"
};